export default "__VITE_ASSET__CiJSYmj4__"